import { isDevelopment } from './config';
import { createStore, applyMiddleware, compose  } from 'redux';
import reduxThunk from 'redux-thunk';
import reducers from './redux/reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let store;
if (isDevelopment) {
  store = createStore(reducers, {}, composeEnhancers(applyMiddleware(reduxThunk)));
} else {
  store = createStore(reducers, {}, applyMiddleware(reduxThunk));
}

export default store;